import cx from "classnames";
import React from "react";
import styles from "./Icon.scss";
import arrowDown from "./images/arrowDown.svg";
import calendar from "./images/calendar.svg";
import chainring from "./images/Chainring.svg";
import circleFacebook from "./images/circleFacebook.svg";
import circlePlus from "./images/CirclePlus.svg";
import circleTwitter from "./images/circleTwitter.svg";
import circleX from "./images/circleX.svg";
import circleXFilled from "./images/circleXFilled.svg";
import clock from "./images/Clock.svg";
import cupOutline from "./images/cupOutline.svg";
import distance from "./images/Distance.svg";
import downChevron from "./images/DownChevron.svg";
import download from "./images/download.svg";
import elevation from "./images/Elevation.svg";
import embed from "./images/embed.svg";
import envelope from "./images/envelope.svg";
import facebook from "./images/facebook.svg";
import farthingWithFlat from "./images/FarthingWithFlat.svg";
import gallery from "./images/gallery.svg";
import gavel from "./images/gavel.svg";
import gavelOutline from "./images/gavelOutline.svg";
import halfStar from "./images/halfStar.svg";
import heading from "./images/Heading.svg";
import heartFilled from "./images/heartFilled.svg";
import heartOutline from "./images/heartOutline.svg";
import help from "./images/Help.svg";
import leftChevron from "./images/LeftChevron.svg";
import map from "./images/map.svg";
import marker from "./images/Marker.svg";
import menu from "./images/menu.svg";
import mobileDevice from "./images/mobileDevice.svg";
import paragraph from "./images/paragraph.svg";
import pencil from "./images/Pencil.svg";
import photo from "./images/Photo.svg";
import pin from "./images/pin.svg";
import rightChevron from "./images/RightChevron.svg";
import rotateLeft from "./images/rotateLeft.svg";
import rotateRight from "./images/rotateRight.svg";
import rwgps from "./images/rwgps.svg";
import squareFb from "./images/squareFb.svg";
import squareInsta from "./images/squareInsta.svg";
import squareTwitter from "./images/squareTwitter.svg";
import star from "./images/star.svg";
import starOutline from "./images/starOutline.svg";
import trash from "./images/trash.svg";
import upChevron from "./images/upChevron.svg";
import upload from "./images/Upload.svg";
import visibility from "./images/visibility.svg";
import visibilityHidden from "./images/visibilityHidden.svg";
import x from "./images/X.svg";

const mappings = {
  arrowDown,
  calendar,
  chainring,
  circleFacebook,
  circlePlus,
  circleTwitter,
  circleX,
  circleXFilled,
  clock,
  cupOutline,
  distance,
  downChevron,
  download,
  elevation,
  embed,
  envelope,
  facebook,
  farthingWithFlat,
  gallery,
  gavel,
  gavelOutline,
  halfStar,
  heading,
  heartFilled,
  heartOutline,
  help,
  leftChevron,
  map,
  marker,
  menu,
  mobileDevice,
  paragraph,
  pencil,
  photo,
  pin,
  rightChevron,
  rotateLeft,
  rotateRight,
  rwgps,
  squareFb,
  squareInsta,
  squareTwitter,
  star,
  starOutline,
  trash,
  upChevron,
  upload,
  visibility,
  visibilityHidden,
  x,
};

export const Icon = ({ i, className, style, size = 12, alignMiddle = true, ...props }) => (
  <i
    {...props}
    className={cx(className, styles.Icon, alignMiddle && styles.alignMiddle)}
    style={{ width: size, height: size, ...style }}
    dangerouslySetInnerHTML={{ __html: mappings[i] }}
  />
);
